import React from 'react';
import { Outlet } from 'react-router-dom';
import { motion } from 'framer-motion';
import Header from './Header';
import Footer from './Footer';

const AnimatedBackground = () => (
  <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden">
    {/* Floating particles */}
    {[...Array(30)].map((_, i) => (
      <motion.div
        key={`p-${i}`}
        className="absolute rounded-full"
        style={{
          width: Math.random() * 3 + 1,
          height: Math.random() * 3 + 1,
          left: `${Math.random() * 100}%`,
          top: `${Math.random() * 100}%`,
          background: ['#00E5FF', '#0047FF', '#8B5CF6', '#00FF9D'][i % 4],
        }}
        animate={{
          y: [0, -100 - Math.random() * 150, 0],
          x: [0, (Math.random() - 0.5) * 80, 0],
          opacity: [0.05, 0.4, 0.05],
          scale: [1, 1.5, 1],
        }}
        transition={{
          duration: 8 + Math.random() * 14,
          repeat: Infinity,
          delay: Math.random() * 10,
          ease: 'easeInOut',
        }}
      />
    ))}

    {/* Large ambient orbs */}
    <motion.div
      className="absolute w-[700px] h-[700px] rounded-full"
      style={{ top: '5%', left: '10%', background: 'radial-gradient(circle, rgba(0,229,255,0.06) 0%, transparent 65%)' }}
      animate={{ x: [0, 120, 0], y: [0, 60, 0], scale: [1, 1.2, 1] }}
      transition={{ duration: 22, repeat: Infinity, ease: 'easeInOut' }}
    />
    <motion.div
      className="absolute w-[600px] h-[600px] rounded-full"
      style={{ bottom: '10%', right: '5%', background: 'radial-gradient(circle, rgba(0,71,255,0.06) 0%, transparent 65%)' }}
      animate={{ x: [0, -100, 0], y: [0, -80, 0], scale: [1.1, 0.9, 1.1] }}
      transition={{ duration: 18, repeat: Infinity, ease: 'easeInOut' }}
    />
    <motion.div
      className="absolute w-[500px] h-[500px] rounded-full"
      style={{ top: '40%', right: '25%', background: 'radial-gradient(circle, rgba(139,92,246,0.05) 0%, transparent 65%)' }}
      animate={{ x: [0, -70, 30, 0], y: [0, 50, -30, 0] }}
      transition={{ duration: 25, repeat: Infinity, ease: 'easeInOut' }}
    />
    <motion.div
      className="absolute w-[400px] h-[400px] rounded-full"
      style={{ top: '60%', left: '30%', background: 'radial-gradient(circle, rgba(0,255,157,0.04) 0%, transparent 65%)' }}
      animate={{ x: [0, 80, -40, 0], y: [0, -60, 40, 0] }}
      transition={{ duration: 20, repeat: Infinity, ease: 'easeInOut' }}
    />

    {/* Animated grid lines */}
    <motion.div
      className="absolute inset-0 opacity-[0.03]"
      style={{
        backgroundImage: 'linear-gradient(var(--color-primary) 1px, transparent 1px), linear-gradient(90deg, var(--color-primary) 1px, transparent 1px)',
        backgroundSize: '80px 80px',
      }}
      animate={{ backgroundPosition: ['0px 0px', '80px 80px'] }}
      transition={{ duration: 40, repeat: Infinity, ease: 'linear' }}
    />

    {/* Scanning line effect */}
    <motion.div
      className="absolute left-0 right-0 h-px"
      style={{ background: 'linear-gradient(90deg, transparent, rgba(0,229,255,0.15), transparent)' }}
      animate={{ top: ['-5%', '105%'] }}
      transition={{ duration: 8, repeat: Infinity, ease: 'linear' }}
    />
    <motion.div
      className="absolute top-0 bottom-0 w-px"
      style={{ background: 'linear-gradient(180deg, transparent, rgba(0,71,255,0.1), transparent)' }}
      animate={{ left: ['-5%', '105%'] }}
      transition={{ duration: 12, repeat: Infinity, ease: 'linear' }}
    />
  </div>
);

const Layout = () => {
  return (
    <div className="min-h-screen flex flex-col bg-[var(--bg-primary)] relative">
      <AnimatedBackground />
      <Header />
      <main className="flex-1 relative z-10">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
